/**
 * Filter names holds the name of a filter.
 * The name key is what is shown in the url
 * The order of the filters, will be the order in the menu
 *
 */

import { isNetherlands } from '@utilities/is-netherlands';

const FILTER_ORDER_NL = [
    'price',
    'propertyTypes',
    'status',
    'districts',
    'projectPhases',
    'rooms',
    'livingArea',
    'plotArea',
    'rental',
    'sunDirection',
    'apartmentBuildings',
];

const FILTER_ORDER_DE = [
    'price',
    'livingArea',
    'status',
    'rooms',
    'propertyTypes',
    'plotArea',
    'sunDirection',
    'districts',
    'projectPhases',
    'rental',
    'apartmentBuildings',
];

export const getFilterOrder = () => (isNetherlands() ? FILTER_ORDER_NL : FILTER_ORDER_DE);
